module.exports = __webpack_public_path__ + "static/img/main-project.9d6ea68e.png";